"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KetteUtil = void 0;
const Kette_1 = require("./Kette");
const echain_shared_articles_1 = require("@igus/echain-shared-articles");
const ArticleUtils_1 = require("../ArticleUtils");
class KetteUtil {
    static artNrHasPlusSign(kette, artNrCountry) {
        if (!kette)
            return false;
        const artNr = ArticleUtils_1.ArticleUtils.getQuoteArtNr(kette, artNrCountry);
        return Boolean(artNr === null || artNr === void 0 ? void 0 : artNr.includes('+'));
    }
    static getKetteBySerieKuerzel(ketten, serieKuerzel) {
        if (!serieKuerzel.length)
            return undefined;
        const serieKuerzelUppercase = serieKuerzel.toUpperCase();
        const kette = ketten.find((k) => { var _a, _b; return ((_b = (_a = k.SerieRef) === null || _a === void 0 ? void 0 : _a.Kuerzel) === null || _b === void 0 ? void 0 : _b.toUpperCase()) === serieKuerzelUppercase; });
        return kette;
    }
    static artNrHasPlusSignBySerieKuerzel(ketten, serieKuerzel, artNrCountry) {
        if (!(ketten === null || ketten === void 0 ? void 0 : ketten.length))
            return false;
        if (!serieKuerzel.length)
            return false;
        const kette = this.getKetteBySerieKuerzel(ketten, serieKuerzel);
        return this.artNrHasPlusSign(kette, artNrCountry);
    }
    static artNrHasPlusSignBySerieId(ketten, serieRefId) {
        if (!(ketten === null || ketten === void 0 ? void 0 : ketten.length))
            return false;
        const kette = ketten.find((k) => { var _a; return ((_a = k === null || k === void 0 ? void 0 : k.SerieRef) === null || _a === void 0 ? void 0 : _a.Id) === serieRefId; });
        return this.artNrHasPlusSign(kette);
    }
    /**
     * Retrieves StandardLink for RolEchain or KetteModel
     * until "standard" chains have all a StandardLinkRef & StandardLink EKE-11282
     */
    static getStandardLink(ketteOrModel) {
        const ketteModel = ketteOrModel instanceof Kette_1.Kette ? ketteOrModel.toModel() : Kette_1.Kette.fromJson(ketteOrModel).toModel();
        if ((0, echain_shared_articles_1.isRolEchainUnion)(ketteModel)) {
            return ketteModel.StandardLink;
        }
        return ketteModel;
    }
    /**
     * Retrieves true if Kettensystem equal E4.1
     */
    static isSystemE41(kette) {
        const echainSystem = this.getStandardLink(kette).EchainSystem;
        const e41Systems = ['E4_1', 'E4_1_esd', 'E4_1_tube'];
        return Boolean(echainSystem && e41Systems.includes(echainSystem));
    }
    /**
     * Retrieves true if Kettensystem equal E4.1
     */
    static isSystemE41L(kette) {
        const echainSystem = this.getStandardLink(kette).EchainSystem;
        const e41LSystems = ['E4_1_light', 'E4_1_light_tube'];
        return Boolean(echainSystem && e41LSystems.includes(echainSystem));
    }
    /**
     * Retrieves true if Kettensystem equal E4Q
     */
    static isSystemE4Q(kette) {
        const echainSystem = this.getStandardLink(kette).EchainSystem;
        const e4QSystems = ['E4_Q'];
        return Boolean(echainSystem && e4QSystems.includes(echainSystem));
    }
    /*
     * Extracts Radius and Rückwärtiger Biegeradius from IndexBiegeradius
     * @param indexBiegeradius The indexBiegeradius to parse
     * @returns An object with r and rbr
     */
    static splitBiegeradiusIntoRAndRbr(indexBiegeradius = '') {
        const [r = '', rbr = ''] = indexBiegeradius.split('/');
        return { r, rbr };
    }
    /**
     * Retrieves the radius part of the indexBiegeradius
     *
     * @returns The radius
     */
    static indexBiegeradiusR(kette) {
        return this.splitBiegeradiusIntoRAndRbr(kette.IndexBiegeradius).r;
    }
    /**
     * Retrieves the rückwärtiger radius part of the indexBiegeradius
     *
     * @returns The rückwärtiger radius
     */
    static indexBiegeradiusRBR(kette) {
        return this.splitBiegeradiusIntoRAndRbr(kette.IndexBiegeradius).rbr;
    }
    static isSerieESkin(ketteJson) {
        return ketteJson.KetteSerieType === echain_shared_articles_1.KetteSerieType.eskin;
    }
}
exports.KetteUtil = KetteUtil;
//# sourceMappingURL=KetteUtil.js.map